<apx-chart #chartspark3 [series]="chartAreaSparkline3Options.series" [chart]="commonAreaSparlineOptions.chart"
  [stroke]="commonAreaSparlineOptions.stroke" [yaxis]="commonAreaSparlineOptions.yaxis"
  [fill]="commonAreaSparlineOptions.fill" [title]="chartAreaSparkline3Options.title"
  [subtitle]="chartAreaSparkline3Options.subtitle"></apx-chart>
